// re.rejouis.fr — barre panier persistante (bas d'écran).
import { Icons, LARGEUR_MAX } from './ui.jsx';
import { fmtEuro } from '../lib/format.js';
import { repartition } from '../lib/rachat.js';

export default function PanierBar({ panier, go }) {
  if (!panier.length) return null;
  const rep = repartition(panier);
  const nb = panier.reduce((s, l) => s + (l.lot ? l.quantite || 0 : 1), 0);
  return (
    <div style={{ position: 'fixed', left: 0, right: 0, bottom: 0, padding: '10px 14px 22px', zIndex: 30, maxWidth: LARGEUR_MAX, margin: '0 auto',
      background: 'linear-gradient(to top, var(--blanc) 72%, transparent)' }}>
      <button onClick={() => go('panier')} className="anim-pop" style={{ display: 'flex', alignItems: 'center', width: '100%', gap: 12, padding: '12px 12px 12px 18px',
        background: 'var(--rouge)', color: '#fff', borderRadius: 999, boxShadow: '0 6px 20px rgba(242,68,68,0.32)' }}>
        <span style={{ fontSize: 13.5, fontWeight: 600 }}>{nb} jouet{nb > 1 ? 's' : ''}</span>
        <span style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.78)' }}>{rep.virement
          ? (rep.bon > 0 ? `${fmtEuro(rep.bon)} de crédit + ${fmtEuro(rep.virement)} de virement` : `${fmtEuro(rep.virement)} par virement`)
          : `${fmtEuro(rep.bon)} de crédit`}</span>
        <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase' }}>
          Mon panier <Icons.chev size={16} />
        </span>
      </button>
    </div>
  );
}
